import { type InsuranceCorporateIdentity } from "../types";

export function ScheufelenLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <clipPath id="clip0_31_4782">
          <rect
            width="436"
            height="167"
            fill="white"
            transform="translate(38 172)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clip0_31_4782)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M228.038 301.74C228.678 301.74 253.226 303.03 253.226 283.691C253.226 274.206 246.082 268.589 237.29 267.391V267.207C244.709 265.827 251.578 260.853 251.578 252.658C251.578 240.963 241.135 235.345 228.678 235.253H196.986V301.741H228.038M215.306 288.848V274.482H227.305C231.426 274.759 233.991 278.258 233.991 281.942C233.991 286.086 230.602 288.848 226.022 288.848H215.306ZM215.306 248.144H225.29C229.594 248.144 232.801 250.815 232.801 254.59C232.801 259.655 229.594 261.589 224.649 261.589L215.306 261.68V248.144Z"
          fill="#006FB4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M279.272 263.118L279.302 235.27H260.985V301.758H279.302L279.315 267.942L301.287 301.758H323.594L298.143 264.556L321.763 235.27H300.463L279.272 263.118Z"
          fill="#006FB4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M348.369 263.118L348.397 235.27H330.078V301.758H348.397L348.41 267.942L370.382 301.758H392.69L367.239 264.556L390.861 235.27H369.556L348.369 263.118Z"
          fill="#006FB4"
        />
        {/* Additional paths for the complete logo */}
      </g>
    </svg>
  );
}

export const Scheufelen: InsuranceCorporateIdentity = {
  id: "scheufelen",
  name: "BKK Scheufelen",
  logo: ScheufelenLogo,
  backgroundColor: "#FFFFFF",
  textColor: "#006FB4",
  wildcard: "bkk scheufelen",
  type: "statutory",
};
